import React from 'react';
import { useLocation } from 'react-router-dom';
import { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import t from '@jetshop/intl';
import { ReactComponent as CheckIcon } from '../../svg/Check.svg';
import { ReactComponent as Settings } from '../../svg/Settings.svg';
import { MenuButton } from '../Layout/Header/Header';
import Badge from '../ui/Badge';
import { useModelFilter } from './ModelFilterContext';
import { ModelFilterDrawer } from './ModelFilterDrawer';

export function useIsModelFilterRoute() {
  const location = useLocation();

  return location.pathname === '/modellfilter';
}

export function ModelFilterButton() {
  const { data: modelFilters } = useModelFilter();
  const isModellfilterRoute = useIsModelFilterRoute();

  const hasFilters =
    modelFilters &&
    Object.values(modelFilters).some(
      filter => filter !== null && filter.length > 0
    );

  return (
    <>
      <DrawerTrigger id="model-filter-drawer" preventOverflow={true}>
        {drawer => (
          <>
            <MenuButton
              className="header-button"
              onClick={drawer.isOpen ? drawer.hideTarget : drawer.showTarget}
            >
              <Settings />
              <span>{t('Model filter')}</span>
              {isModellfilterRoute && hasFilters && (
                <Badge text={<CheckIcon />} />
              )}
            </MenuButton>
          </>
        )}
      </DrawerTrigger>

      <DrawerTarget id="model-filter-drawer">
        {({ hideTarget, isOpen }) => (
          <ModelFilterDrawer isOpen={isOpen} onClose={hideTarget} />
        )}
      </DrawerTarget>
    </>
  );
}
